// VIA PRIME — gerçek işletme içeriği (mevcut siteden birebir alınmıştır).
// Supabase tabloları henüz kurulmadıysa site bu içerikle çalışmaya devam eder.

export const CONTACT = {
  address: "Maslak Mahallesi, Büyükdere Caddesi No:255, Sarıyer / İstanbul",
  phone: "+90 212 000 00 00",
  email: "info@viaprime.com",
  hours: "Pazartesi - Cumartesi: 09:00 - 19:00",
  whatsapp: "https://wa.me/905555555555", // PLACEHOLDER numara — gerçek numara ile değiştirilecek
};

export const MARQUEE_ITEMS = [
  "SIFIR BAKIM RİSKİ",
  "VERGİ AVANTAJI",
  "7/24 DESTEK",
  "2026 SIFIR KM FİLO",
  "İSTANBUL MERKEZLİ",
];

export const ADVANTAGES = [
  {
    key: "bakim",
    title: "Sıfır Bakım Riski",
    desc: "Tüm bakım, sigorta ve lastik maliyetleri paketinize dahildir.",
    image:
      "https://images.pexels.com/photos/6870326/pexels-photo-6870326.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "vergi",
    title: "Kurumsal Vergi Avantajı",
    desc: "Operasyonel kiralama ile şirket bütçenizi koruyun.",
    image:
      "https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    key: "destek",
    title: "7/24 Concierge Servisi",
    desc: "İstanbul merkezli uzman ekibimizle her an yanınızdayız.",
    image:
      "https://images.pexels.com/photos/28123710/pexels-photo-28123710.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    key: "filo",
    title: "2026 Sıfır KM Filo",
    desc: "En yeni model premium sedan araçlarla prestiji yaşayın.",
    image: null,
  },
];

export const CORPORATE_SOLUTIONS = [
  {
    title: "Operasyonel Kiralama",
    desc: "Araç yönetim yükünü ortadan kaldırın, operasyonel kiralamanın tüm avantajlarından yararlanın.",
  },
  {
    title: "Vergisel Avantaj",
    desc: "Kiralama bedeli gider olarak gösterilir, KDV iadesi imkânı sağlar.",
  },
  {
    title: "Nakit Akışı Koruması",
    desc: "Yüksek araç yatırımı yapmadan prestijli bir filo.",
  },
  {
    title: "VIP Şoförlü Hizmet",
    desc: "Üst düzey yöneticileriniz için profesyonel şoför desteği.",
  },
];

export const FALLBACK_VEHICLES = [
  {
    id: "fallback-e180",
    slug: "mercedes-e180-2026",
    name: "Mercedes-Benz E180 Sedan",
    segment: "Prestige Executive",
    badge: "En Çok Tercih Edilen",
    price_label: "200.000 TL",
    year: 2026,
    color: "Obsidian Siyah",
    engine: "1.5L Turbo Mild-Hybrid 170 HP",
    transmission: "9G-TRONIC Otomatik",
    fuel: "Benzin / Hybrid",
    seats: 5,
    description:
      "E-Serisi'nin en zarif temsilcisi. Üst düzey yöneticiler ve kurumsal makam aracı kullanımı için tasarlandı.",
    features: [
      "MBUX Süper Ekran",
      "Burmester® 4D Ses Sistemi",
      "Panoramik Cam Tavan",
      "VIP Şoför Hizmeti Opsiyonu",
      "Airmatic Havalı Süspansiyon",
    ],
    image_url:
      "https://images.pexels.com/photos/17233279/pexels-photo-17233279.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    gallery: [],
    sort_order: 1,
  },
  {
    id: "fallback-a200",
    slug: "mercedes-a200-2026",
    name: "Mercedes-Benz A200 Sedan",
    segment: "Compact Luxury",
    badge: "Yeni Filo",
    price_label: "125.000 TL",
    year: 2026,
    color: "Cosmos Siyah",
    engine: "1.3L Turbo 163 HP",
    transmission: "7G-DCT Otomatik",
    fuel: "Benzin",
    seats: 5,
    description:
      "Şehir içi ve kısa yolculuklar için kompakt lüksün en zarif temsilcisi.",
    features: [
      "AMG Line Tasarım",
      "Geniş Ekran Kokpit",
      "Ambiyans Aydınlatma (64 Renk)",
      "Keyless-Go",
      "Aktif Park Yardımcısı",
    ],
    image_url:
      "https://images.unsplash.com/photo-1624085568108-36410cfe4d24?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxtZXJjZWRlcyUyMGElMjBjbGFzcyUyMHNlZGFuJTIwd2hpdGV8ZW58MHx8fHwxNzkyNTA1NDE5fDA&ixlib=rb-4.1.0&q=85",
    gallery: [],
    sort_order: 2,
  },
  {
    id: "fallback-superb",
    slug: "skoda-superb-2026",
    name: "Skoda Superb Prestige",
    segment: "Business Class",
    badge: "Fiyat / Performans",
    price_label: "115.000 TL",
    year: 2026,
    color: "Magic Siyah",
    engine: "1.5 TSI mHEV 150 HP",
    transmission: "7 İleri DSG Otomatik",
    fuel: "Mild Hybrid Benzin",
    seats: 5,
    description:
      "İş yolculukları için üstün konfor ve mükemmel fiyat/performans dengesi.",
    features: [
      "Canton 14 Hoparlör Ses Sistemi",
      "Masajlı ve Isıtmalı Koltuklar",
      "Matrix LED Ön Farlar",
      "Elektrikli Bagaj Kapağı",
      "Sınıfının En Geniş Diz Mesafesi",
    ],
    image_url:
      "https://images.pexels.com/photos/15194845/pexels-photo-15194845.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    gallery: [],
    sort_order: 3,
  },
];

export const FALLBACK_POSTS = [
  {
    id: "fallback-post-1",
    slug: "2026-mercedes-e-class-incelemesi",
    title: "2026 Mercedes E-Class: Prestijin Yeni Tanımı",
    excerpt:
      "Yeni nesil E-Serisi, kurumsal yöneticiler için yeniden tanımlandı.",
    image_url:
      "https://images.unsplash.com/photo-1610099610040-ab19f3a5ec35?crop=entropy&cs=srgb&fm=jpg&q=85",
    published: true,
    created_at: "2026-01-15T09:00:00Z",
    content: `Mercedes-Benz E-Serisi, onlarca yıldır iş dünyasının makam aracı tercihi oldu. 2026 model yılıyla birlikte E180 Sedan, bu mirası dijital çağın beklentileriyle buluşturuyor.

Yeni E-Serisi'nin kabini, MBUX Süper Ekran ve Burmester® 4D ses sistemiyle artık yalnızca bir ulaşım aracı değil; hareket hâlinde bir çalışma ve dinlenme alanı. Panoramik cam tavan ve Airmatic havalı süspansiyon, İstanbul trafiğinde bile yolculuğu sakin bir deneyime dönüştürüyor.

Kurumsal kullanımda öne çıkan nokta ise öngörülebilirlik: mild-hybrid motor teknolojisi yakıt maliyetlerini dengelerken, uzun dönem operasyonel kiralama modeliyle bakım ve sigorta süreçleri tamamen kiralama paketine dahil ediliyor.

VIA PRIME filosundaki 2026 model E180 Sedan, üst düzey yöneticiler ve makam aracı kullanımı için Obsidian Siyah rengiyle sunuluyor. VIP şoför hizmeti opsiyonuyla birlikte, şirketler hem prestij hem de operasyonel rahatlık elde ediyor.`,
  },
  {
    id: "fallback-post-2",
    slug: "sirketler-icin-filo-yonetimi",
    title: "Şirketler İçin Modern Filo Yönetimi",
    excerpt: "Operasyonel kiralama ile şirketinizin verimliliğini artırın.",
    image_url:
      "https://images.unsplash.com/photo-1587813369290-091c9d432daf?crop=entropy&cs=srgb&fm=jpg&q=85",
    published: true,
    created_at: "2026-01-10T09:00:00Z",
    content: `Şirket araçları, çoğu işletme için görünmeyen bir operasyon yüküdür: bakım planlaması, sigorta yenilemeleri, lastik değişimleri, hasar süreçleri ve ikinci el değer riski... Modern filo yönetimi, bu yükün tamamının uzman bir iş ortağına devredilmesi anlamına gelir.

Operasyonel kiralama modelinde şirketiniz aracı satın almaz; kullanım hakkını aylık sabit bir bedelle kiralar. Böylece araç maliyeti bilançoda yatırım kalemi olmaktan çıkar, öngörülebilir bir gider kalemi hâline gelir.

Bu modelin bir diğer faydası da güncellik. Filonuz her kiralama dönemi sonunda yenilenir; çalışanlarınız ve yöneticileriniz her zaman güncel model, güvenlik donanımı tam araçlarla yola çıkar.

VIA PRIME olarak İstanbul merkezli ekibimizle kurumsal filo ihtiyaçlarınızı tek noktadan yönetiyoruz: bakım, sigorta, lastik ve 7/24 destek tek pakette.`,
  },
  {
    id: "fallback-post-3",
    slug: "uzun-donem-arac-kiralama-avantajlari",
    title: "Uzun Dönem Araç Kiralamanın 7 Kurumsal Avantajı",
    excerpt:
      "Kurumsal filo yönetiminde uzun dönem kiralamanın şirket bütçenize ve operasyonlarınıza sağladığı avantajları inceliyoruz.",
    image_url:
      "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85",
    published: true,
    created_at: "2026-01-05T09:00:00Z",
    content: `Uzun dönem araç kiralama, kurumsal dünyada giderek daha yaygın tercih edilen bir finansman modeli. İşte şirketler için öne çıkan yedi avantaj:

1. Sabit ve öngörülebilir maliyet: Aylık kira bedeli dışında sürpriz masraf yoktur; bütçe planlaması kolaylaşır.

2. Vergi avantajı: Kiralama bedeli gider olarak kaydedilir ve KDV yönünden avantaj sağlar.

3. Bakım yükümlülüğünden kurtulma: Periyodik bakım, sigorta ve lastik maliyetleri kiralama paketine dahildir.

4. Nakit akışı koruması: Yüksek tutarlı araç yatırımı yerine aylık ödemelerle sermayeniz işinizde kalır.

5. Güncel model filo: Kiralama dönemi sonunda araçlar yenilenir; filonuz her zaman güncel kalır.

6. Operasyonel yükün azalması: Hasar, muayene ve sigorta süreçleri kiralayan firma tarafından yönetilir.

7. Ölçeklenebilirlik: İhtiyacınıza göre araç sayısını artırıp azaltabilirsiniz.

VIA PRIME'ın 2026 model sıfır kilometre filosuyla bu avantajların tamamından prestijli bir sedan seçkisiyle yararlanabilirsiniz.`,
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1592309905620-e5b59f6dcb98?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBibGFjayUyMG1lcmNlZGVzJTIwc2VkYW4lMjBkcml2aW5nfGVufDB8fHx8MTc5MjUwNTQxOXww&ixlib=rb-4.1.0&q=85";

export const FLEET_BAND_IMAGE =
  "https://images.pexels.com/photos/37772238/pexels-photo-37772238.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const CORPORATE_IMAGE =
  "https://images.pexels.com/photos/10211565/pexels-photo-10211565.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
